<template>
  <div id="app">
    <div class="container"
      style="background-color: azure; margin-bottom: 20px; border-bottom:1px #EFEFEF solid; box-shadow: 0px 0px 5px #999; border-radius: 0px 0px 10px 10px;">
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
          <img src="@/assets/icon-sijakon.png" style="width:50px; margin-right:10px;" align="left"> <router-link
            class="navbar-brand" :to="{ name: 'Home' }">SI<b>JAKON</b></router-link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'Home' }" aria-current="page">HOME</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'Tentang-Kami' }" aria-current="page">TENTANG
                  KAMI</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'FAQ' }" aria-current="page">FAQ</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'user-manual' }" aria-current="page">User
                  Manual</router-link>
              </li>
              <li class="nav-item">
                <a href="/admin" class="nav-link active" aria-current="page">LOGIN</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <router-view></router-view>
    <div style="background-color:black;margin:0;">
      <div class="container" style="padding:2.5rem 0;">
        <div class="row" style="background-color:black;margin:0;">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-12 col-md-2 text-center">
                <img src="@/assets/icon-sijakon.png" style="width:8rem;margin-bottom:3rem;">
                <br>
                <span class="text-white">S I <b>J A K O N</b></span>

              </div>
              <div class="col-xs-12 col-md-8 text-center">
                <img src="@/assets/pemko.png" class="mb-2" style="width:5.5rem; margin-top:2rem;">
                <div class="text-white">Call Center : 0778 - 8014354</div>
                <div class="text-white mb-2">Email : disciptakaru@batam.go.id</div>
              </div>
              <div class="col-xs-12 col-md-2 d-sm-block d-md-none" style="text-align:center;">
                <router-link :to="{ name: 'Terms' }" class="text-white"
                  style="font-size:1.1rem;text-decoration: none;">Syarat & Ketentuan</router-link><br><br>
                <a href="#" class="text-white" style="font-size:1.1rem;text-decoration: none;">Kebijakan
                  Privasi</a><br><br>
                <a href="#" class="text-white" style="font-size:1.1rem;text-decoration: none;">Pusat Bantuan</a><br><br>
              </div>
              <div class="col-xs-12 col-md-2 d-none d-md-block" style="text-align:right;">
                <router-link :to="{ name: 'Terms' }" class="text-white"
                  style="font-size:1.1rem;text-decoration: none;">Syarat & Ketentuan</router-link><br><br>
                <a href="#" class="text-white" style="font-size:1.1rem;text-decoration: none;">Kebijakan
                  Privasi</a><br><br>
                <router-link :to="{ name: 'pusat-bantuan' }" class="text-white"
                  style="font-size:1.1rem;text-decoration: none;">Pusat Bantuan</router-link><br>
              </div>
            </div>

            <div class="row" style="padding-bottom:1rem;">
              <div class="col-xs-12 text-white text-center">
                Hak Cipta &copy; 2021 oleh <b>Dinas Cipta Karya dan Tata Ruang Kota Batam</b>
              </div>
              <div class="col-xs-12 text-white text-center">
                Pemerintah kota Batam
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {

  }
}
</script>

<style></style>
